// This file is auto-generated during build
// Version from package.json
export const APP_VERSION = "2.1.0";

// Build timestamp
export const BUILD_TIMESTAMP = "2026-11-03T08:41:53.231Z";

// Helper function to get version display string
export const getVersionDisplay = () => `v${APP_VERSION}`;

// Helper function to get full version info
export const getVersionInfo = () => ({
    version: APP_VERSION,
    display: getVersionDisplay(),
    buildDate: BUILD_TIMESTAMP.split('T')[0],
    buildTime: BUILD_TIMESTAMP
});

// Helper function to get version with build info for debugging
export const getVersionWithBuild = () => {
    const buildDate = BUILD_TIMESTAMP.split('T')[0];
    return `${getVersionDisplay()} (${buildDate})`;
};

// Version comparison utilities
export const compareVersions = (version1: string, version2: string): number => {
    const v1Parts = version1.split('.').map(Number);
    const v2Parts = version2.split('.').map(Number);
    
    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
        const v1Part = v1Parts[i] || 0;
        const v2Part = v2Parts[i] || 0;
        
        if (v1Part > v2Part) return 1;
        if (v1Part < v2Part) return -1;
    }
    
    return 0;
};

// Check if a version is newer than current
export const isNewerVersion = (newVersion: string): boolean => {
    return compareVersions(newVersion, APP_VERSION) > 0;
};

// Get version hash for cache busting
export const getVersionHash = (): string => {
    return "2.1.0-2026-11-03T08-41-53-231Z";
};
